import { useCallback, useRef } from "react";

const SWIPE_THRESHOLD = 50;

const useSwipe = ({ onLeft, onRight, onUp, onDown }) => {
  const touchStart = useRef(null);

  const handleTouchStart = useCallback(e => {
    const touch = e.touches[0];
    touchStart.current = { x: touch.clientX, y: touch.clientY };
  }, []);

  const handleTouchEnd = useCallback(
    e => {
      if (!touchStart.current) return;
      const touch = e.changedTouches[0];
      const dx = touch.clientX - touchStart.current.x;
      const dy = touch.clientY - touchStart.current.y;
      touchStart.current = null;

      const absDx = Math.abs(dx);
      const absDy = Math.abs(dy);

      if (absDx < SWIPE_THRESHOLD && absDy < SWIPE_THRESHOLD) return;

      if (absDx > absDy) {
        if (dx < 0) onLeft?.();
        else onRight?.();
      } else {
        if (dy < 0) onUp?.();
        else onDown?.();
      }
    },
    [onLeft, onRight, onUp, onDown],
  );

  return { onTouchStart: handleTouchStart, onTouchEnd: handleTouchEnd };
};

export default useSwipe;
